import React from 'react';
import { Grid, Typography } from 'housecall-ui';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import HousecallProLogo from 'housecall-ui/dist/IconsAndImages/Logos/HousecallProLogo';

export const Footer = () => {
  return (
    <Grid container justify="center" spacing={1}>
      <Grid item>
        <Typography variant="caption">Powered by</Typography>
      </Grid>
      <Grid item>
        <HousecallThemeProvider>
          <HousecallProLogo color="primary" width={90} height={13} />
        </HousecallThemeProvider>
      </Grid>
    </Grid>
  );
};
